export default "__VITE_ASSET__370fcbcc__"